export const PR_ENTRY_POINT_URL_NAME = 'pr_entry_point_url';
